import styled, { css } from "styled-components";

import Grid from "src/library/components/Hedron";

/**
 * Inherited settings Radio row component
 */
export const InheritedRadioRow = styled(Grid.Bounds)`
  ${({ theme }) => css`
    align-items: center;

    > input {
      margin: ${theme.spacing.margins.md} 0;
      margin-right: ${theme.spacing.margins.md};
    }

    .setting-element {
      &.inactive {
        opacity: 0.5;]

        * {
          cursor: pointer;
        }
      }
    }
  `};
`;
